module.exports = "<ng-progress [spinner]=\"false\" [thick]=\"true\" color=\"#FFA300\"></ng-progress>\n<router-outlet></router-outlet>"